module.exports = __webpack_public_path__ + "static/media/Organization_8.b9147fd6.svg";